import "./index.mcss";
import "@bux/input/text/string.mts";
import "@bux/input/text/password.mts";

import { assert_never, SEC } from "@arlib/lib.mts";
import { BuxFormDirect } from "@bux/form/direct.mts";
import BuxInputTextPassword from "@bux/input/text/password.mts";
import BuxInputTextString from "@bux/input/text/string.mts";
import { go_back, go_next } from "@bux/singleton/nav_stack.mts";

import { login_submit } from "./indexλ.mts";

const $form = SEC(HTMLFormElement, document, "#form");
// The alert box bux renders at the top of the form.
const $form_alert = SEC(HTMLElement, $form, "error");
const $username = SEC(BuxInputTextString, $form, "[name=username]");
const $password = SEC(BuxInputTextPassword, $form, "[name=password]");
const $error = SEC(HTMLParagraphElement, $form, ".x-error");

new BuxFormDirect({
    $form,
    api: login_submit.api,
    on_cancel: go_back,

    get: () => ({
        username: $username.value ?? null,
        password: $password.value ?? null,
    }),

    out: (output) => {
        $error.textContent = "";
        if ("InputErr" in output) {
            const e = output.InputErr[0];
            // Every message the server returned, in the form's alert box at the
            // top of the screen. bux styles <error> as the red alert and clears
            // it on each submit; a per-field set_e would leave the form natively
            // invalid and silently suppress the next Save.
            $form_alert.textContent = [e.username, e.password]
                .filter((m): m is string => Boolean(m))
                .join(" ");
            return;
        }
        if ("Failed" in output) {
            $error.textContent = output.Failed.message;
            return;
        }
        if ("Ok" in output) {
            go_next(output.Ok.redirect_url);
            return;
        }
        assert_never(output);
    },
});
